"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useListStyle = exports.ListStyleProvider = void 0;
const react_1 = require("react");
const createPropsContextProvider_1 = require("../../utils/createPropsContextProvider");
const createUseDefinedContext_1 = require("../../utils/hooks/createUseDefinedContext");
const listStyleContext = (0, react_1.createContext)(undefined);
exports.ListStyleProvider = (0, createPropsContextProvider_1.createPropsContextProvider)(listStyleContext);
exports.useListStyle = (0, createUseDefinedContext_1.createUseDefinedContext)(listStyleContext, 'Please wrap your component with ListStyleProvider');
//# sourceMappingURL=ListStyleProvider.js.map